import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToolbarItem, useToast, Button } from '@kinesis/bungle';
import { useIsEditor } from '@/hooks/use-is-editor';
import { useInventoryId } from '@/hooks/use-inventory-id';
import { useNewPathwayScenarioMutation } from '@/api/pathway-scenarios';
import { pathwayScenarioPath } from '@/links';

const ToolbarPathwayScenarios = () => {
  const [newPathwayScenario, { isLoading: isCreating }] =
    useNewPathwayScenarioMutation();
  const navigate = useNavigate();
  const inventoryId = useInventoryId();
  const toast = useToast('globalTop');
  const isEditor = useIsEditor();

  const onCreatePathwayScenario = useCallback(async () => {
    try {
      const data = await newPathwayScenario({
        inventoryId,
        name: 'New scenario',
      }).unwrap();
      navigate(pathwayScenarioPath(inventoryId, data.id));
    } catch (e) {
      toast('Could not create scenario.', { variant: 'error' });
    }
  }, [newPathwayScenario, inventoryId, navigate, toast]);

  return isEditor ? (
    <>
      <ToolbarItem>
        <Button
          onClick={onCreatePathwayScenario}
          variant='primary'
          loading={isCreating}
        >
          New scenario
        </Button>
      </ToolbarItem>
    </>
  ) : null;
};

export { ToolbarPathwayScenarios };
